import { render, staticRenderFns } from "./TransferAttributes.vue?vue&type=template&id=781174ab&scoped=true&"
import script from "./TransferAttributes.vue?vue&type=script&lang=js&"
export * from "./TransferAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781174ab",
  null
  
)

export default component.exports